/* eslint-disable valid-jsdoc */
module.exports = (function () {
    const { Application } = require('utils/framework');
    const { InPageComps, EventType } = require('constants/events');
    const { isUfeEnvQA, isUfeEnvLocal } = require('utils/Env');
    const emotion = require('emotion');

    var React = require('react'),
        ReactDOM = require('react-dom'),
        Comps = {},
        InflatorComps = Sephora.Util.InflatorComps,
        startTime;

    // For render time performance logging
    if (isUfeEnvQA || isUfeEnvLocal) {
        Sephora.Util.InflatorComps.totalRenderTime = 0;
        Sephora.Util.InflatorComps.totalInclusiveRenderTime = 0;
        Sephora.Util.InflatorComps.rootRenderTime = 0;
    }

    // All Async Loadable Components Should Be Included Here
    // It is possible for InflatorComps.Comps to already exist at this point so check first
    Comps = InflatorComps.Comps = InflatorComps.Comps ? InflatorComps.Comps : {};
    var asyncComponents = require('build/asyncList');
    Object.assign(Comps, asyncComponents);

    /**
     * Actually render the component (wraps react)
     * @param componentClass
     * @param props
     * @param element
     * @returns {*}
     */
    InflatorComps.render = function (componentClass, props = {}, element, hydrate = true) {
        let className;

        if (typeof componentClass === 'string') {
            className = componentClass;
        } else if (componentClass.prototype) {
            className = componentClass.prototype.class;
        } else {
            className = componentClass.class;
        }

        if (typeof componentClass === 'string') {
            // eslint-disable-next-line no-param-reassign
            componentClass = Comps[className].getReactClass();
        } else if (Comps[className] === undefined) {
            // TO DO: It looks like this code may never be used. Could possibly be cleaned up.
            Comps[className] = {
                class: componentClass.prototype.originClass,
                getReactClass: () => componentClass
            };
        }

        // Mark root components with red border
        if (process.env.NODE_ENV === 'development' && Sephora.debug.showRootComps) {
            element.style.border = '1px solid red';
        }

        let componentProps = props;

        if (typeof props === 'string') {
            try {
                componentProps = JSON.parse(props);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);

                return null;
            }
        }

        // For render time performance logging
        if (isUfeEnvQA || isUfeEnvLocal) {
            startTime = performance.now();
        }

        const createdReactElement = React.createElement(componentClass, componentProps);

        const render = !hydrate ? ReactDOM.render : ReactDOM.hydrate;
        const renderedElement = render(createdReactElement, element);

        //For render time performance logging
        if (isUfeEnvQA || isUfeEnvLocal) {
            const comp = InflatorComps.Comps[className].getReactClass();

            if (!comp.rootRenderTime) {
                InflatorComps.Comps[className].rootRenderTime = 0;
            }

            const renderTime = performance.now() - startTime;
            InflatorComps.Comps[className].rootRenderTime += renderTime;
            Sephora.Util.InflatorComps.rootRenderTime += renderTime;
        }

        return renderedElement;
    };

    // Initialize page components
    Sephora.Util.Perf.report('Add Components Chunk to Page');

    // require.ensure is used to package nested requires in components.chunk.js
    // rather than priority.bundle.js in order to keep priority.bundle.js lean
    require.ensure(
        [],
        function (require) {
            Application.events.dispatchServiceEvent(InPageComps, EventType.Loaded);
            //Create Promises
            require('analytics/promises')(Sephora.analytics);
            var inPageComponents = require('../../build/inPageList');
            Object.assign(Comps, inPageComponents);
            Application.events.dispatchServiceEvent(InPageComps, EventType.Ready);

            const postDOMContentLoadInitialization = () => {
                if (Sephora.emotionIds && Sephora.emotionIds.length) {
                    emotion.hydrate(Sephora.emotionIds.split(','));
                }

                Application.events.dispatchServiceEvent(InPageComps, EventType.ServiceCtrlrsApplied, true);
            };

            if (Sephora.DOMContentLoadedFired) {
                postDOMContentLoadInitialization();
            } else {
                window.addEventListener('DOMContentLoaded', postDOMContentLoadInitialization);
            }

            if (Sephora.isLazyLoadEnabled) {
                const LazyLoader = require('utils/framework/LazyLoad').LazyLoaderInstance;
                LazyLoader.start();
            }
        },
        'components'
    );

    return InflatorComps;
}());
